<div class="contact-details-container" [formGroup]="formGroup">

  <!-- Branch Information Card -->
  <div class="section-card">
    <p class="note">Address as in NRIC (Please do not enter PO Box Address)</p>
    <div class="container-fluid">
      <!-- <h4>Address as in NRIC </h4> -->

      <div class="row g-3">

        <!-- House -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">store</mat-icon> -->
            House/Block
          </label>

          <mat-form-field class="custom-form-field w-100">
            <input matInput formControlName="house" placeholder="Enter House" required>
            @if(this.formGroup.controls["house"].invalid
            && (this.formGroup.controls["house"].touched ||
            this.formGroup.controls["house"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["house"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Street -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">star</mat-icon> -->
            Street
          </label>

          <mat-form-field class="custom-form-field w-100">
            <input matInput formControlName="street" placeholder="Enter Street" required>
            @if(this.formGroup.controls["street"].invalid
            && (this.formGroup.controls["street"].touched ||
            this.formGroup.controls["street"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["street"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Financial Services Manager -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">supervisor_account</mat-icon> -->
            Level & Unit
          </label>

          <mat-form-field class="custom-form-field w-100">
            <input matInput formControlName="level" placeholder="Enter Level" required>
            @if(this.formGroup.controls["level"].invalid
            && (this.formGroup.controls["level"].touched ||
            this.formGroup.controls["level"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["level"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">supervisor_account</mat-icon> -->
            Building Name (Optional)
          </label>

          <mat-form-field class="custom-form-field w-100">
            <input matInput formControlName="building" placeholder="Enter Building Name">
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">supervisor_account</mat-icon> -->
            Postal Code
          </label>

          <mat-form-field class="custom-form-field w-100">
            <input matInput formControlName="postalCode" placeholder="Enter Postal Code" required>
            @if(this.formGroup.controls["postalCode"].invalid
            && (this.formGroup.controls["postalCode"].touched ||
            this.formGroup.controls["postalCode"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["postalCode"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>
        <p class="field-label">Contact Number</p>
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">supervisor_account</mat-icon> -->
            Home (Optional)
          </label>

          <mat-form-field class="custom-form-field w-100">
            <input matInput formControlName="contactNumber"  maxlength="13" 
             inputmode="numeric" (keypress)="allowNumbersOnly($event)" (input)="sanitizeNumericInput($event, 'contactNumber')"
              placeholder="Enter Home Number">
              @if (
                  this.formGroup.controls['contactNumber'].invalid &&
                  (this.formGroup.controls['contactNumber'].touched ||
                  this.formGroup.controls['contactNumber'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['contactNumber'].errors?.['pattern'] ||
                    this.formGroup.controls['contactNumber'].errors?.['maxlength']) {
                    <span>Only numbers are allowed, maximum 13 digits</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">supervisor_account</mat-icon> -->
            Mobile Number
          </label>

          <mat-form-field class="custom-form-field w-100">
            <input matInput formControlName="mobileNumber"  maxlength="13" 
             inputmode="numeric" (keypress)="allowNumbersOnly($event)" (input)="sanitizeNumericInput($event, 'mobileNumber')"
              placeholder="Enter Mobile Number">
            @if(this.formGroup.controls["mobileNumber"].invalid
            && (this.formGroup.controls["mobileNumber"].touched ||
            this.formGroup.controls["mobileNumber"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["mobileNumber"].errors?.["required"]) {
              <span>{{message}}</span>
              }@else if (this.formGroup.controls['mobileNumber'].errors?.['pattern'] ||
                this.formGroup.controls['mobileNumber'].errors?.['maxlength']) {
              <span>Only numbers are allowed, maximum 13 digits</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">supervisor_account</mat-icon> -->
            Personal Email address
          </label>

          <mat-form-field class="custom-form-field w-100">
            <input matInput formControlName="personalEmailAddress" type="email"
              placeholder="Enter Personal Email address" required>
            @if(this.formGroup.controls["personalEmailAddress"].invalid
            && (this.formGroup.controls["personalEmailAddress"].touched ||
            this.formGroup.controls["personalEmailAddress"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["personalEmailAddress"].errors?.["required"])
              {
              <span>{{message}}</span>
              }@else if
              (this.formGroup.controls["personalEmailAddress"].errors?.["email"])
              {
              <span>Invalid Personal EmailAddress.</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

      </div>

    </div>

  </div>

</div>

@if(readonly() === false){
@if(isVisible() === true){
<div class="editor-actions">
  <button mat-stroked-button type="button" (click)="cancelSection()">Cancel</button>
  <button type="button" class="save-btn" (click)="saveSection()">
    <mat-icon>save</mat-icon>Save</button>
</div>
}@else{
<div class="form-actions">

  <button mat-raised-button class="save-btn" (click)="saveAndContinue()">

    <span>Save & Continue</span>
    <mat-icon>arrow_forward</mat-icon>

  </button>

</div>
}
}